export default __webpack_public_path__ + "static/media/boxes_yellow.68cd1439.svg";